import React from "react";
import Ionicons from "react-native-vector-icons/Ionicons";

import { ADMIN_TOKENS } from "../../../../../styles/adminTokens";
import { MessageListItem } from "../../messages/shared";
import type { TMessageConversationListItem } from "../types";
import { formatPhoneNumberDisplay } from "../../../../../utils/phoneNumber";

type MessageConversationItemProps = {
  conversation: TMessageConversationListItem;
  selected: boolean;
  onPress: (conversationUuid: string) => void;
  onAssignToPatient: (conversation: TMessageConversationListItem) => void;
  assignSubmitting: boolean;
  formatDateTime: (value?: string | null) => string;
};

const MessageConversationItem: React.FC<MessageConversationItemProps> = ({
  conversation,
  selected,
  onPress,
  onAssignToPatient,
  assignSubmitting,
  formatDateTime,
}) => {
  const hasUnread = (conversation.unreadCount || 0) > 0;
  const patientLabel = (conversation.patientLabel || "").trim();
  const previewText =
    (conversation.lastMessagePreview || "").trim() || "No messages yet.";
  const formattedParticipant = formatPhoneNumberDisplay(
    conversation.participantE164,
    {
      fallback: conversation.participantE164 || "-",
    },
  );
  const title = patientLabel
    ? `${patientLabel} • ${formattedParticipant}`
    : formattedParticipant;

  return (
    <MessageListItem
      title={title}
      preview={previewText}
      timestamp={formatDateTime(conversation.lastMessageAt)}
      selected={selected}
      unread={hasUnread}
      onPress={() => onPress(conversation.conversationUuid)}
      accessibilityLabel={`Open conversation with ${formattedParticipant}`}
      onSecondaryAction={() => onAssignToPatient(conversation)}
      secondaryActionLabel={`Assign conversation with ${formattedParticipant} to patient`}
      secondaryActionDisabled={assignSubmitting}
      secondaryActionIcon={
        <Ionicons
          name="person-add-outline"
          size={16}
          color={ADMIN_TOKENS.color.accentDark}
        />
      }
      hidePreviewRow
    />
  );
};

export default MessageConversationItem;
